import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import {
  isMobile,
  isIE,
  isSafari,
  isIOS,
  isMobileSafari,
  isAndroid,
} from "react-device-detect";
import logo from "../../images/connect-logo.png";

const AppUrl = () => {
  const renderMobileMessage = () => {
    if (isIOS) {
      return (
        <Typography
          variant="body1"
          style={{ marginTop: "50px", textAlign: "center" }}
        >
          Thank you for signing up!
          <br/>
          <br/>
          Please download the Connect app for your device using the button below and sign in there with the username and password you just created.{' '}
          <br/>
          <br/>
          <a
            href="https://apps.apple.com/nl/app/smartspotter-connect/id1622049631"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/appstore.svg"
              alt="Download on the App Store"
              style={{ width: '150px', height: 'auto' }}
            />
          </a>
        </Typography>
      );
    } else if (isAndroid) {
      return (
        <Typography
          variant="body1"
          style={{ textAlign: "center" }}
        >
          Thank you for signing up!
          <br/>
          <br/>
          Please download the Connect app for your device using the button below and sign in there with the username and password you just created.{' '}
          <br/>
          <br/>
          <br/>
          <br/>
          <a
            href="https://play.google.com/store/apps/details?id=com.smartconnect.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/public/assets/playstore.png"
              alt="Download on the Play Store"
              style={{ width: '250px', height: 'auto' }}
            />
          </a>

        </Typography>
      );
    } else {
      return (
        <Typography
          variant="body1"
          style={{ textAlign: "center" }}
        >

          Thank you for signing up!
          <br/>
          <br/>
          Please download the Connect app for your device by scanning the QR code or by using the buttons below and sign in there with the username and password you just created.{' '}
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <svg width="200" height="200" shape-rendering="crispEdges" xmlns="
http://www.w3.org/2000/svg"
viewBox="0 0 29 29"><path fill="#fff" d="M0,0 h29v29H0z"></path><path fill="#000" d="M0 0h7v1H0zM8 0h2v1H8zM16 0h5v1H16zM22,0 h7v1H22zM0 1h1v1H0zM6 1h1v1H6zM14 1h1v1H14zM16 1h1v1H16zM18 1h1v1H18zM22 1h1v1H22zM28,1 h1v1H28zM0 2h1v1H0zM2 2h3v1H2zM6 2h1v1H6zM8 2h1v1H8zM11 2h4v1H11zM20 2h1v1H20zM22 2h1v1H22zM24 2h3v1H24zM28,2 h1v1H28zM0 3h1v1H0zM2 3h3v1H2zM6 3h1v1H6zM8 3h2v1H8zM11 3h1v1H11zM13 3h2v1H13zM17 3h1v1H17zM19 3h1v1H19zM22 3h1v1H22zM24 3h3v1H24zM28,3 h1v1H28zM0 4h1v1H0zM2 4h3v1H2zM6 4h1v1H6zM8 4h4v1H8zM15 4h1v1H15zM19 4h1v1H19zM22 4h1v1H22zM24 4h3v1H24zM28,4 h1v1H28zM0 5h1v1H0zM6 5h1v1H6zM9 5h1v1H9zM12 5h2v1H12zM16 5h5v1H16zM22 5h1v1H22zM28,5 h1v1H28zM0 6h7v1H0zM8 6h1v1H8zM10 6h1v1H10zM12 6h1v1H12zM14 6h1v1H14zM16 6h1v1H16zM18 6h1v1H18zM20 6h1v1H20zM22,6 h7v1H22zM9 7h1v1H9zM11 7h1v1H11zM14 7h1v1H14zM16 7h2v1H16zM19 7h2v1H19zM0 8h4v1H0zM6 8h1v1H6zM8 8h1v1H8zM14 8h1v1H14zM17 8h3v1H17zM21 8h1v1H21zM24 8h3v1H24zM28,8 h1v1H28zM2 9h4v1H2zM7 9h1v1H7zM9 9h1v1H9zM14 9h1v1H14zM16 9h1v1H16zM18 9h3v1H18zM22 9h3v1H22zM28,9 h1v1H28zM0 10h1v1H0zM4 10h1v1H4zM6 10h3v1H6zM14 10h1v1H14zM16 10h3v1H16zM20 10h2v1H20zM23 10h2v1H23zM26 10h2v1H26zM0 11h2v1H0zM3 11h1v1H3zM5 11h1v1H5zM11 11h3v1H11zM18 11h1v1H18zM22 11h1v1H22zM28,11 h1v1H28zM0 12h3v1H0zM4 12h6v1H4zM11 12h1v1H11zM15 12h1v1H15zM17 12h1v1H17zM20 12h1v1H20zM23 12h1v1H23zM25 12h2v1H25zM0 13h2v1H0zM5 13h1v1H5zM8 13h4v1H8zM13 13h5v1H13zM19 13h1v1H19zM21 13h2v1H21zM26,13 h3v1H26zM0 14h1v1H0zM3 14h1v1H3zM6 14h1v1H6zM9 14h1v1H9zM12 14h1v1H12zM14 14h1v1H14zM17 14h1v1H17zM19 14h2v1H19zM22 14h2v1H22zM26,14 h3v1H26zM0 15h2v1H0zM9 15h1v1H9zM12 15h2v1H12zM16 15h1v1H16zM20 15h1v1H20zM22 15h1v1H22zM24 15h1v1H24zM27 15h1v1H27zM0 16h2v1H0zM4 16h1v1H4zM6 16h1v1H6zM8 16h4v1H8zM18 16h1v1H18zM20 16h2v1H20zM23 16h3v1H23zM27 16h1v1H27zM1 17h1v1H1zM3 17h3v1H3zM7 17h1v1H7zM10 17h1v1H10zM12 17h2v1H12zM15 17h1v1H15zM18 17h1v1H18zM20 17h2v1H20zM23 17h1v1H23zM25 17h3v1H25zM0 18h1v1H0zM4 18h4v1H4zM9 18h1v1H9zM11 18h2v1H11zM15 18h2v1H15zM21 18h1v1H21zM23 18h2v1H23zM26 18h1v1H26zM3 19h1v1H3zM7 19h2v1H7zM10 19h1v1H10zM12 19h1v1H12zM15 19h3v1H15zM24 19h1v1H24zM26 19h1v1H26zM1 20h2v1H1zM4 20h1v1H4zM6 20h1v1H6zM9 20h5v1H9zM15 20h3v1H15zM19 20h8v1H19zM8 21h3v1H8zM12 21h3v1H12zM17 21h4v1H17zM24,21 h5v1H24zM0 22h7v1H0zM11 22h3v1H11zM16 22h1v1H16zM18 22h3v1H18zM22 22h1v1H22zM24 22h2v1H24zM27 22h1v1H27zM0 23h1v1H0zM6 23h1v1H6zM10 23h1v1H10zM20 23h1v1H20zM24 23h2v1H24zM27 23h1v1H27zM0 24h1v1H0zM2 24h3v1H2zM6 24h1v1H6zM10 24h1v1H10zM12 24h1v1H12zM14 24h1v1H14zM17 24h1v1H17zM20 24h5v1H20zM26 24h1v1H26zM0 25h1v1H0zM2 25h3v1H2zM6 25h1v1H6zM8 25h1v1H8zM11 25h2v1H11zM14 25h4v1H14zM20 25h2v1H20zM23 25h3v1H23zM28,25 h1v1H28zM0 26h1v1H0zM2 26h3v1H2zM6 26h1v1H6zM8 26h1v1H8zM11 26h1v1H11zM13 26h1v1H13zM17 26h1v1H17zM23 26h1v1H23zM26 26h1v1H26zM28,26 h1v1H28zM0 27h1v1H0zM6 27h1v1H6zM8 27h1v1H8zM10 27h2v1H10zM14 27h1v1H14zM16 27h1v1H16zM19 27h2v1H19zM22 27h2v1H22zM25 27h1v1H25zM27 27h1v1H27zM0 28h7v1H0zM8 28h3v1H8zM12 28h1v1H12zM14 28h2v1H14zM18 28h6v1H18zM25 28h1v1H25zM27 28h1v1H27z">
</path></svg>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <a
            href="https://play.google.com/store/apps/details?id=com.smartconnect.app"
            target="_blank"
            rel="noopener noreferrer"
            style={{padding: "25px"}}
          >
            <img
              src="/assets/playstore.png"
              alt="Download on the App Store"
              style={{ width: '300px', height: 'auto' }}
            />
          </a>
          <a
            href="https://apps.apple.com/nl/app/smartspotter-connect/id1622049631"
            target="_blank"
            rel="noopener noreferrer"
            style={{padding: "25px"}}

          >
            <img
              src="/assets/appstore.png"
              alt="Download on the App Store"
              style={{ width: '300px', height: 'auto' }}
            />
          </a>

        </Typography>)
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "20px",
      }}
    >
      <img style={{marginTop: "10px", marginBottom: "10px"}} src={logo} />
      <p style={{ marginTop: "50px" }}>{renderMobileMessage()}</p>
    </Box>
  );
};

export default AppUrl;
